import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, EventEmitter, Output , ElementRef, HostListener, Input} from '@angular/core';
import { Observer, Observable } from 'rxjs';
import { UploadFile } from 'ng-zorro-antd';
import { debug } from 'util';
import { DevicePriceInfo, ProductModel } from 'src/app/model/selfcareproducts';
import { PeriodModel } from 'src/app/model/PeriodModel';
import { CustomerProspectService } from 'src/app/services/customer-prospect.service';
import { PaymentService } from 'src/app/services/payment.service';
import { ConfigurationService } from 'src/app/services/common/configuration.service';
import { Prospect } from 'src/app/model/Prospect';
import { Utilities } from 'src/app/services/common/Utility';
import { PaymentModel } from 'src/app/model/PaymentModel';
import { CyberPay, CyberPayLogModel, CyberPaySetTransactionRequest } from 'src/app/model/CyberPay';
import { Guid } from 'guid-typescript';
import { environment } from 'src/environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { HttpEventType, HttpClient } from '@angular/common/http';
 

@Component({
  selector: 'app-voicereg',
  templateUrl: './voicereg.component.html',
  styleUrls: ['./voicereg.component.css']
})
export class VoiceregComponent implements OnInit {
  fileList: UploadFile[] = [];
  file1: UploadFile;
  file2: UploadFile;


  displayProducts : ProductModel[];
  servicePlanAmount : string; 
 selectedProductID: number = 169;
 periods :PeriodModel [] =[];
 selectedPeriodID : number=1;
 selectedPeriod : string;
 AmountPayable: number = 0;

  modemDevices :      DevicePriceInfo []=[];// DeviceElement[]=[];
  selectedModemID:number;
  selectedModem:string;
  selectedModemPrice:number = 0;;
  currentproductPrice:number=0;

  ModemName: string;
  ModemPrice:number;
  ModemNAVCode:string;
  ModemNAVPrice :number;

  ProductName:string  = "Voice";
  ProductID:number=169;
  
  
  ProductPrice :number=500.00 * 100;
  PeriodNo:number=1;


  DeliveryAddress:string="";
  FirstName:string;
  LastName:string;
  EmailAddress: string;
  MobilePhone:string;


  uploading = false;n
  fileList1: UploadFile[] = [];
  fileList2: UploadFile[] = [];

  public progress: number;
  public message: string;

  prospectForm:FormGroup;
   

  isSubmitted: boolean = false;  

  @Output() public onUploadFinished = new EventEmitter();




  generatePeriods()
  {
  
    var period1: PeriodModel = {id: 1, Name:'1 Month' };
 
       
       
     this.periods.push(period1);
     for (let i = 2; i < 25; i++) {
      
      var newPeriod: PeriodModel = {id: i, Name: i + ' months' };
    
      this.periods.push(newPeriod);


      
    }
 
  }


  changePeriod(id:number)
  {
   
    var period = this.periods.find(e => e.id == id);
    this.selectedPeriod = period.Name;
    this.selectedPeriodID = period.id;
    this. AmountPayable = (500 * this. selectedPeriodID) ;
    this.PeriodNo = period.id;

  }


  constructor(private  customerService: CustomerProspectService ,
    private paymentService: PaymentService,
     private config: ConfigurationService,
     private toastrService:ToastrService,
     private formBuilder: FormBuilder, private http:HttpClient,
     private _el: ElementRef) {

      this.generatePeriods();

      const emailPattern = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
      this.prospectForm = this.formBuilder.group({
        FirstName: [null, [Validators.required]],
        LastName: [null, [Validators.required]],
        EmailAddress: [null, [Validators.required,   Validators.pattern(emailPattern)]],
        MobilePhone: [null, [Validators.required]     ],
      DeliveryAddress: [null, [Validators.required]], 
      
      });




    
      }

 
 

      
  handleChange({ file, fileList }: { [key: string]: any }): void
   {
     

     if ( file.type =='image/png'||  file.type =='image/jpeg' || file.type=='image/jpg' ||file.type=='application/pdf' || file.type =='application/vnd.openxmlformats-officedocument.wordprocessingml.document') 
     {
      const isLt3M = file.size / 1024 / 1024 < 3;
       if (!isLt3M)   {
        this.toastrService.error('file must be smaller than 3MB!');
         
        return;
      }
// do the needful
this.fileList = this.fileList.concat(file);
this.file1 = file;
      const status = file.status;
    if (status !== 'uploading') 
    {
      console.log(file, fileList);
    }
    if (status === 'done') 
    {
      this.toastrService.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error')
     {
      this.toastrService.error(`${file.name} file upload failed.`);
    }

     }

 else
 {
  this.toastrService.error('You selected an invalid file type');
  
  return;

 }

     
  
  }

   
  beforeUpload1 = (file: UploadFile) => {

    return new Observable((observer: Observer<boolean>) => {
      const isImage = file.type.startsWith('image');

      if (isImage) {
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
          this.toastrService.error('file must be smaller than 3MB!');
          observer.complete();
          return;
        }
        this.fileList1 = this.fileList1.concat(file);
        observer.next(false);
        observer.complete();



      } else {
        this.toastrService.error('You can only upload image file');
        observer.complete();
        return;
      }

    });
  }
  
  beforeUpload2 = (file: UploadFile) => {

    return new Observable((observer: Observer<boolean>) => {
      const isImage = file.type.startsWith('image');

      if (isImage) {
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
          this.toastrService.error('file must be smaller than 3MB!');
          observer.complete();
          return;
        }
        this.fileList2 = this.fileList2.concat(file);
        observer.next(false);
        observer.complete();



      } else {
        this.toastrService.error('You can only upload image file');
        observer.complete();
        return;
      }

    });
  }

  onSubmit(formGroup: FormGroup)
     {
  this.isSubmitted = true;  

      if(this.prospectForm.invalid)
      {
        this.toastrService.error("Please enter valid information!");
        return;
      }
   
      var prospect: Prospect = {} as Prospect;
      prospect.MobilePhone = formGroup.value.MobilePhone;
      prospect.FirstName= formGroup.value.FirstName;
      prospect.LastName= formGroup.value.LastName;
      prospect.EmailAddress= formGroup.value.EmailAddress;
      prospect.AmountPayable =this.AmountPayable;
      prospect.AddressStreet =   formGroup.value.DeliveryAddress;
 



        let today = new Date().toISOString().slice(0, 10);
        let date: Date = new Date();  
        
       // prospect.MerchantRef=MerchantRef;
       prospect.CreatedBy = prospect.FirstName + " " + prospect.LastName;
       prospect.CreationDate = date;
       prospect.ContactMethod =  prospect.ContactMethod == null ? "Email" : prospect.ContactMethod;
       prospect.OperatorCode = this.config.OperatorCode;
       prospect.AddressStreet = this.DeliveryAddress  ;
       prospect.AddressArea = "N";
       prospect.AddressZip="NA";
       prospect.AddressCity = "NA";
       prospect.AddressState = "NA";
       prospect.AddressCountry="NA";
       prospect.ProductID = this.ProductID;
       prospect.Device1 =this. ModemName;
       prospect.Device1Cost = this.ModemPrice;
       prospect.Device1NAVCode =this. ModemNAVCode;
       prospect.Device1NAVCost = this.ModemNAVPrice;
       prospect.NoofDays = this.selectedPeriodID;




       // Validation
       if(!prospect.FirstName || !prospect.LastName || !prospect.EmailAddress  || !prospect.MobilePhone)
       {
         this.toastrService.error("User information required!");
         return;
         
       }
       if(!this.fileList1[0] || !this.fileList2[0])
       {
         this.toastrService.error("Utility Bills and ID documents are rquired... ");
   
         return;
       }
       
       let paymentModel : PaymentModel = Utilities.MapProspect(prospect);
       // map before posting to endpint
        
        
       
    this.customerService.savenewProspect(paymentModel).subscribe(    
      data => {    
          
        if(data.Status==0)    
        {
          this.toastrService.error( data.Message); 

        }
        
        if(data.Status==1)    
        {   
          var paymentModel :  PaymentModel = data.Result;  
          try{
             var CustID:number =  paymentModel.Customer.ProspectID;

            this.uploadFile(CustID);
          }
          catch{}

          
          var portalcode :string;
         var  OperatorID: number = this.config.OperatorID;
          var  resuiredPortalCode:string = "PortalCode" + OperatorID;
          resuiredPortalCode  =resuiredPortalCode==this.config.PortalCode1 ? this.config.PortalCode1:this.config.PortalCode4;

          
          let cyberPay = {} as CyberPay;
          cyberPay. RedirectLink = prospect.Provider;
          cyberPay.portalCode =resuiredPortalCode;
          cyberPay.CustomerID = paymentModel.Customer.ProspectID;
          cyberPay.provider_id = prospect.ProviderId;
          cyberPay.CustomerDesc = "Prospect Reference No";
          cyberPay.Email = paymentModel.Customer.EmailAddress;
          cyberPay.Value = prospect.AmountPayable ;
          cyberPay.  FullName = paymentModel.Customer.FirstName + " " + paymentModel.Customer.LastName;
          cyberPay.Session = "NewSignUp-"+ paymentModel.Customer.ProspectID + "-" +  Guid.create().toString().toUpperCase().split('-').join('')
          cyberPay. ItemCode =this. ModemNAVCode ;
          cyberPay. ItemName = "Prospect";
          cyberPay.PhoneNumber = paymentModel.Customer.MobilePhone;
          cyberPay.amount = prospect.AmountPayable  ;
          cyberPay.i_product = this.ProductID  ;
        
         this.PostCyberpay(cyberPay);
        

         //  
         
        }    
        else{   
       
          this.toastrService.error( data.Message); 
          
              
     
        }    
      },     
      error => {    
         
       // this.loading = false;  
       this.toastrService.error("Error logging in"); 

       
      }); 
    
      }

      
  PostCyberpay(cyberPay: CyberPay)
  {
 
    let cyberPayModel = {} as CyberPay;
    let MerchantRef = Guid.create().toString().toUpperCase().split('-').join('');
    
    
    cyberPay.RedirectLink  = environment.CyberPayReturnURL;//this.config.CyberPayReturnURL;
   
    let cyberPayPaymentRequest = {} as CyberPaySetTransactionRequest;
    cyberPayPaymentRequest.Currency = "NGN";
    cyberPayPaymentRequest.CustomerId = cyberPay.CustomerID.toString();
    cyberPayPaymentRequest.Amount =  cyberPay.amount * 100;
     cyberPayPaymentRequest.CustomerEmail = cyberPay.Email;
    cyberPayPaymentRequest.MerchantRef =MerchantRef;
    cyberPayPaymentRequest.CustomerMobile= cyberPay.PhoneNumber;
    cyberPayPaymentRequest.CustomerName=cyberPay.FullName ;
    cyberPayPaymentRequest.Description = cyberPay.ItemName + "-" + cyberPay.i_account;
    cyberPayPaymentRequest.IntegrationKey=environment.IntegrationKey;
     cyberPayPaymentRequest.ReturnUrl = environment.CyberPayReturnURL;
     cyberPayPaymentRequest.ProductCode = cyberPay.i_product.toString();
    cyberPayPaymentRequest.WebhookUrl = environment.webhookUrl;
     
     
    
   let serialisedPayload :string = JSON.stringify(cyberPayPaymentRequest).toString();


     
    this.paymentService.cyberPaySetTransaction(cyberPayPaymentRequest).subscribe(    
      res => {    
        
        if(res.succeeded== true)    
        {       
          


          let date: Date = new Date();
       
            

            var robj = res.data;
            var redirectUr = robj.redirectUrl;
            var transactionReference =robj. transactionReference;
            //var TheObj = robj.data;
            //var redirectUr = TheObj.redirectUrl;
            
  
          
            window.location.href = redirectUr;


   // Log Cyberpay Request

  
   let cyberPayLogModel = {} as CyberPayLogModel;

   cyberPayLogModel.CustomerDesc = cyberPay.CustomerDesc;
   cyberPayLogModel.CustomerID = cyberPay.CustomerID;
   cyberPayLogModel.DateCreated= date.toDateString();
   cyberPayLogModel.Email=cyberPay.Email;
   cyberPayLogModel.FullName = cyberPay.FullName;
   cyberPayLogModel.IsSuccessful = false;
   cyberPayLogModel.ItemCode = cyberPay.ItemCode;
   cyberPayLogModel.ItemName = cyberPay.ItemName;
   cyberPayLogModel.OperatorID = cyberPay.OperatorID;
   cyberPayLogModel.PhoneNumber = cyberPay.PhoneNumber;
   cyberPayLogModel.PortalCode = cyberPay.portalCode;
   cyberPayLogModel.RedirectLink=cyberPay.RedirectLink;
   cyberPayLogModel.Request_Payload=serialisedPayload;
   cyberPayLogModel.Session=cyberPay.Session;
   cyberPayLogModel.Transaction_status="PENDING";;
   cyberPayLogModel.Value =cyberPay.amount;
   cyberPayLogModel.amount = cyberPay.amount;
   cyberPayLogModel.i_account=cyberPay.i_account;
   cyberPayLogModel.i_customer=cyberPay.i_customer;
   cyberPayLogModel.i_product = cyberPay.i_product;
   cyberPayLogModel.TransRef = transactionReference;
 

   
  
 
   this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).subscribe(res=>{
    console.log(res);
  });


   

       

         // window.location.href = data.data.redirectUrl;


     
          
        

         // this.router.navigate(['/dashboard']);    
         
        }    
        else{   
       
          //this._notificationservice.error("Error logging in"); 
          
              
       //   this.errorMessage = data.Message;    
         // this.alertService.error(this.errorMessage);
        }    
      },     
      error => {    
         
       // this.loading = false;  
      //  this._notificationservice.error("Error logging in"); 

       
      }); 


  }


  public uploadFile = (CustID:number) => {
    /* if (files.length === 0) {
       return;
     }*/
  
     let KyCFile :any =           this.fileList1[0];
     let UtilityBill :any =           this.fileList2[0];
     
     
     //var KYCFileName:string= 
     const formData = new FormData();
     formData.append('KYCfile', KyCFile, KyCFile.name);
     formData.append('UtilityBill', UtilityBill, UtilityBill.name);
     formData.append('CustID',CustID+"");
      var uploadur :string= `${environment.lteHttpBaseUrl}/api/v1/upload`;
  
     this.http.post(uploadur, formData, {reportProgress: true, observe: 'events'})
       .subscribe(event => {
         if (event.type === HttpEventType.UploadProgress)
           this.progress = Math.round(100 * event.loaded / event.total);
         else if (event.type === HttpEventType.Response) {
           this.message = 'Upload success.';
           this.onUploadFinished.emit(event.body);
         }
       });
   }
  ngOnInit() {


  }

}
